export const processCoupleSex = ({ sex1, sex2, t }) => {
	const sexString = `${t("sexOptions.couple")} (${t(
		`sexOptions.${sex1}`
	)} ${t("and")} ${t(`sexOptions.${sex2}`)})`;

	return sexString;
};

export const processCoupleAge = (age1, age2, t) => {
	let ageString = "";
	if (age1 && age2) {
		ageString = ` ${age1} ${t("and")} ${age2} ${t("years")},`;
	}
	return ageString;
};

export const processCoupleSexWithAge = ({ sex1, age1, sex2, age2, t }) => {
	let sexWithAgeString = "";
	if (age1 && age2) {
		sexWithAgeString = `${t("sexOptions.couple")} (${t(
			`sexOptions.${sex1}`
		)} ${age1} ${t("years")}, ${t(`sexOptions.${sex2}`)} ${age2} ${t(
			"years"
		)})`;
	} else {
		sexWithAgeString = `${t("sexOptions.couple")} (${t(
			`sexOptions.${sex1}`
		)} ${t("and")} ${t(`sexOptions.${sex2}`)})`;
	}
	return sexWithAgeString;
};

export const processCoupleSexWithAge_v2 = ({ sex1, age1, sex2, age2, t }) => {
	let sexWithAgeString = "";
	if (age1 && age2) {
		sexWithAgeString = `${t("sexOptions.couple")} (${t(
			`sexOptions.${sex1}`
		)} ${age1}, ${t(`sexOptions.${sex2}`)} ${age2})`;
	} else {
		sexWithAgeString = `${t("sexOptions.couple")} (${t(
			`sexOptions.${sex1}`
		)} ${t("and")} ${t(`sexOptions.${sex2}`)})`;
	}
	return sexWithAgeString;
};

export const processCoupleSexWithAgeNewView = ({
	sex1,
	age1,
	sex2,
	age2,
	t,
}) => {
	const sexWithAgeString = `(${t(`sexOptions.${sex1}`)} ${age1} ${t(
		"common:years"
	)}, ${t(`sexOptions.${sex2}`)} ${age2} ${t("common:years")})`;
	return sexWithAgeString;
};
